export interface SalesInvoiceProductSummaryReport {
  productKey: string;
  productDescription: string;
  composition: string;
  tariffCode: string;
  nettQuantity: number;
  value: number;
}
